if (!customElements.get('l-past-collection')) {
	customElements.define(
		'l-past-collection',
		class LPastCollection extends HTMLElement {
			constructor() {
				super()

				this.setupEvents()
				this.setupCarousel()
			}

			setupEvents() {
				this.modalButtons = document.querySelectorAll('.past-collection__list-item')
				this.bodyEl = document.querySelector('body')
				this.modalEls = document.querySelectorAll('.past-collection__modal')
				this.closeEls = document.querySelectorAll('#bs-close-modal')
				this.overlayEl = document.querySelector('.past-collection__modal-overlay')

				this.modalButtons.forEach((button) => {
					button.addEventListener('click', (e) => {
						const blockId = button.dataset.blockId
						const modalEl = this.querySelector(`[data-modal-id="${blockId}"]`)

						if (!modalEl.classList.contains('bs-modal')) return

						if (!this.overlayEl) return
						this.overlayEl.classList.add('past-collection__modal-overlay--active')

						modalEl.classList.add('open')
						modalEl.classList.add('past-collection__modal--open')
						this.bodyEl.classList.add('bs-modal-open')
					})
				})

				// close modal when clicking close button
				this.closeEls.forEach((button) => {
					button.addEventListener('click', (e) => {
						const currentModalEl = e.currentTarget.closest('.past-collection__modal')
						this.closeModal(currentModalEl)
					})
				})

				// close modal when clicking outside
				this.overlayEl.addEventListener('click', () => {
					this.modalEls.forEach((modal) => {
						this.closeModal(modal)
					})
				})

				// close on esc key press
				document.onkeydown = (evt) => {
					evt = evt || window.event
					var isEscape = false
					if ('key' in evt) {
						isEscape = evt.key === 'Escape' || evt.key === 'Esc'
					} else {
						isEscape = evt.keyCode === 27
					}
					if (isEscape) {
						this.modalEls.forEach((modal) => {
							this.closeModal(modal)
						})
					}
				}
			}

			closeModal(modalEl) {
				if (!modalEl.classList.contains('bs-modal')) return

				if (!this.overlayEl) return
				this.overlayEl.classList.remove('past-collection__modal-overlay--active')

				modalEl.classList.remove('past-collection__modal--open')
				modalEl.classList.remove('open')
				this.bodyEl.classList.remove('bs-modal-open')
			}

			setupCarousel() {
				this.collectionList = this.querySelector('[data-collection-list]')

				this.collectionListFlickity = new ThemeFlickity(this.collectionList, {
					watchCSS: true,
					cellAlign: 'center',
					contain: true,
					pageDots: true,
					initialIndex: 1,
				})

				// Setup click next event
				const carouselPrevBtn = this.querySelector('[data-carousel-prev]')
				const carouselNextBtn = this.querySelector('[data-carousel-next]')
				const carouselLength = parseInt(this.dataset.carouselLength)

				if (carouselPrevBtn) {
					carouselPrevBtn.addEventListener('click', () => {
						this.collectionListFlickity.previous()
					})
				}

				if (carouselNextBtn) {
					carouselNextBtn.addEventListener('click', () => {
						this.collectionListFlickity.next()
					})
				}

				this.collectionListFlickity.on('change', function (index0) {
					if (index0 == 0) {
						carouselPrevBtn && carouselPrevBtn.classList.toggle('is-disabled', index0 == 0)
						carouselNextBtn && carouselNextBtn.classList.toggle('is-disabled', index0 != 0)
					}

					if (index0 == carouselLength - 1) {
						carouselPrevBtn && carouselPrevBtn.classList.toggle('is-disabled', index0 != carouselLength - 1)
						carouselNextBtn && carouselNextBtn.classList.toggle('is-disabled', index0 == carouselLength - 1)
					}

					// carouselDots.forEach((carouselDot, dotIndex0) => {
					// 	carouselDot.classList.toggle('is-active', dotIndex0 == index0)
					// })
				})

				// Setup dots click events
				// const carouselDots = this.querySelectorAll('[data-carousel-dot]')

				// carouselDots.forEach((carouselDot, index0) => {
				// 	carouselDot.addEventListener('click', () => {
				// 		this.collectionListFlickity.select(index0, false, false)
				// 	})
				// })
			}
		}
	)
}

